import newsService from '../../services/newsService'
import Vue from "vue";

const state = {
    news: [],
    text: '',
    loading_new: false,
    loading: true,
};

const actions = {
    getNews({commit, state}) {
        state.loading = true;
        newsService.fetchNews()
            .then(news => {
                commit('setNews', news);
                state.loading = false;
            })
            .catch(error=>{
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информационные посты.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail||"Без описания."}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });
                state.loading = false;
            })
    },
    addNews({commit, state}) {
        state.loading_new = true;
        newsService.postNews({text: state.text})
            .then((newNews) => {
                commit('addNews', newNews);
                state.text = '';
                state.loading_new = false;
            })
            .catch((error) => {
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось добавить информационный пост.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail||"Без описания."}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });
                state.loading_new = false;
            })
    },
    deleteNews({commit}, newsId) {
        newsService.deleteNews(newsId)
            .then(() => {
                commit('deleteNews', newsId)
            })
            .catch((error) => {
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось удалить информационный пост.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail||"Без описания."}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });
            })
    }
};

const mutations = {
    setNews(state, news) {
        state.news = news
    },
    addNews(state, news) {
        state.news.unshift(news)
    },
    deleteNews(state, newsId) {
        state.news = state.news.filter(obj => obj.id !== newsId)
    },
    updateText(state, value) {
        state.text = value
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}